<script lang="ts">
	import Pause from '$lib/icons/pause.svelte';
	import Play from '$lib/icons/play.svelte';
	import { onMount } from 'svelte';
	import Button from './button.svelte';

	interface Props {
		videoElement: HTMLVideoElement | undefined;
		class?: string;
	}

	let { videoElement, class: className }: Props = $props();

	let paused = $state(false);

	function pause() {
		paused = true;
	}

	function unpause() {
		paused = false;
	}

	onMount(() => {
		if (!videoElement) return;

		paused = videoElement.paused;

		videoElement.addEventListener('play', unpause);
		videoElement.addEventListener('pause', pause);

		return () => {
			videoElement.removeEventListener('play', unpause);
			videoElement.removeEventListener('pause', pause);
		};
	});
</script>

<Button
	class={['btn-blur', className]}
	onclick={(e) => {
		e.stopPropagation();

		if (!videoElement) return;

		paused ? videoElement.play() : videoElement.pause();
	}}
	title={paused ? 'Play video' : 'Pause video'}
>
	{#if paused}
		<Play class="w-full translate-x-[1px]" />
	{:else}
		<Pause class="w-full" />
	{/if}
</Button>
